import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Search-engine ownership tags set from Ops → Marketing → SEO (also baked into the HTML at build time).
fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/site-verification`).then((r) => r.json()).then((v) => {
  for (const [name, val] of [["google-site-verification", v.google], ["msvalidate.01", v.bing]]) {
    if (!val || document.querySelector(`meta[name="${name}"]`)) continue;
    const m = document.createElement("meta"); m.name = name; m.content = val; document.head.prepend(m);
  }
}).catch(() => {});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
